(() => {

    class FeaturedProducts {

        constructor(root) {

            this.root = root;

            this.buttons = [
                ...root.querySelectorAll('[data-mode]')
            ];

            this.prices = [
                ...root.querySelectorAll('[data-price]')
            ];

            this.mode = 'one-time';

            this.bind();

        }

        bind() {

            this.buttons.forEach(button => {

                button.addEventListener('click', () => {

                    const mode = button.dataset.mode;

                    if (mode === this.mode) return;

                    this.mode = mode;

                    this.updateButtons();

                    this.updatePrices();

                });

            });

        }

        updateButtons() {

            this.buttons.forEach(button => {

                button.classList.toggle(
                    'is-active',
                    button.dataset.mode === this.mode
                );

            });

        }

        updatePrices() {

            const isMobile = window.matchMedia('(max-width: 576px)').matches;

            this.root
                .querySelectorAll('.featured-product-card')
                .forEach(card => {

                    const isSubscription = this.mode === 'subscription';

                    card.classList.toggle(
                        'is-subscription',
                        isSubscription
                    );

                    card.classList.toggle(
                        'hide-regular-price',
                        isSubscription && isMobile
                    );

                });

        }

    }

    document
        .querySelectorAll('[data-featured-products]')
        .forEach(section => {

            new FeaturedProducts(section);

        });

})();